
import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Blogs from './Components/Blogs';
import Navbar from './Components/Navbar';
import Herosection from './Components/Herosection';
import AllBlogs from './Components/AllBlogs';
import Footer from './Components/Footer';
import ShubhPaisaSection from './Components/Shubhpaisa';
import Transaction from './Components/Transaction';
import Contact from './Components/Contact';
import Career from './Components/Career';
import Track from './Components/Track';
import Preapproveloan from './Components/Preapproveloan';
import ServiceProvider from './Components/Service';
import ExploreProduct from './Components/ExploreProduct';
import TypesPayment from './Components/TypesPayment';
import EMICalculator from './Components/EMI';
import Aboutus from './Components/About';
import Alltypeinsurance from './Components/Alltypeinsurance';
import AllTypeloan from './Components/AllTypeloan';
import InfoModal from './Components/Modal';
import PrivacyPolicy from './Components/Privacy';
import TermsConditions from './Components/Term';
import AllTypePayment from './Components/Alltypepayment';
import JobModal from './Components/JobModal';
import EMIPAGE from './Components/EMIPAGE';
import BlogArticlePage from './Components/BlogArticlepage';
import Individualservice from './Components/Individualservice';
import Shubhbanner from './Components/Shubhbanner';
import Carloan from './Components/Carloan';
import Homeloan from './Components/Homeloan';
import Bikeloan from './Components/Bikeloan';
import Educationloan from './Components/Educationloan';
import Businessloan from './Components/Businessloan';
import HealthInsurance from './Components/HealthInsurance';
import Lifeinsurance from './Components/Lifeinsurance';
import Travelinsurance from './Components/Travelinsurance';
import Bikeinsurance from './Components/Bikeinsurance';
import Carinsurance from './Components/Carinsurance';
import Dth from './Components/Dth';
import Water from './Components/Water';
import Electricity from './Components/Electricity';
import Fastag from './Components/Fastag';
import Gold from './Components/Gold';
import Property from './Components/Property';
import Medical from './Components/Medical';
import Gadget from './Components/Gadget';
import Business from './Components/Business';
import Pipe from './Components/Pipe';
import Cablewire from './Components/Cablewire';
import Broadband from './Components/Broadband';
import Gas from './Components/Gas';
import Homeinsurance from './Components/Homeinsurance';
import Credit from './Components/Credit';
import Explore from './Components/Explore';
import Overview from './Components/Overview';
import MobilePrepaid from './Components/MobilePrepaid';
// import SideNav from './Components/SideNav';

function Home() {
  return (
    <>
      <Navbar />
      <Herosection />
      <ServiceProvider />
      <ExploreProduct />
      <TypesPayment />
      <Shubhbanner />
      <EMICalculator />
      <ShubhPaisaSection />
      <Transaction />
      <Blogs />
      <Footer />
    </>
  );
}


function App() {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/all-blogs" element={<AllBlogs />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/career" element={<Career />} />
          <Route path="/track" element={<Track />} />
          <Route path="/preapproveLoan" element={<Preapproveloan />} />
          <Route path="/about" element={<Aboutus />} />
          <Route path="/EMIPAGE" element={<EMIPAGE />} />
          <Route path="/BlogArticlepage" element={<BlogArticlePage />} />
          <Route path="/alltypeinsurance" element={<Alltypeinsurance />} />
          <Route path="/allTypeloan" element={<AllTypeloan />} />
          <Route path="/alltypepayment" element={<AllTypePayment />} />
          <Route path="/modal" element={<InfoModal />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/term" element={<TermsConditions />} />
          <Route path="/jobmodal" element={<JobModal />} />
          <Route path="/Individualservice" element={<Individualservice />} />
          <Route path="/carloan" element={<Carloan />} />
          <Route path="/homeloan" element={<Homeloan />} />
          <Route path="/bikeloan" element={<Bikeloan />} />
          <Route path="/educationloan" element={<Educationloan />} />
          <Route path="/businessloan" element={<Businessloan />} />
          <Route path="/healthinsurance" element={<HealthInsurance />} />
          <Route path="/lifeinsurance" element={<Lifeinsurance />} />
          <Route path="/travelinsurance" element={<Travelinsurance />} />
          <Route path="/bikeinsurance" element={<Bikeinsurance />} />
          <Route path="/carinsurance" element={<Carinsurance />} />
          <Route path="/mobileprepaid" element={<MobilePrepaid />} />
          <Route path="/dth" element={<Dth />} />
          <Route path="/water" element={<Water />} />
          <Route path="/electricity" element={<Electricity />} />
          <Route path="/fastag" element={<Fastag />} />
          <Route path="/gold" element={<Gold />} />
          <Route path="/property" element={<Property />} />
          <Route path="/medical" element={<Medical />} />
          <Route path="/gadget" element={<Gadget />} />
          <Route path="/business" element={<Business />} />
          <Route path="/pipe" element={<Pipe />} />
          <Route path="/cablewire" element={<Cablewire />} />
          <Route path="/broadband" element={<Broadband />} />
          <Route path="/gas" element={<Gas />} />
          <Route path="/home" element={<Homeinsurance />} />
          <Route path="/credit-card" element={<Credit />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/overview" element={<Overview/>}/>
          {/* <Route path="/SideNav" element={<SideNav/>}/> */}
        </Routes>
      </Router>
  );
}

export default App;